import apiClient from './apiClient';

export const getYuebaorecord = (params) => {
  return apiClient.get('/yuebao_record', { params })
    .then(response => ({
      data: {
        items: response.data.rows,
        total: response.data.count
      }
    }));
};
